/*! (C) Andrea Giammarchi - Mit Style License */
var URLSearchParams = URLSearchParams || function () { "use strict"; function URLSearchParams(query) { var index, key, value, pairs, i, length, dict = Object.create(null); this[secret] = dict; if (!query) return; if (typeof query === "string") { if (query.charAt(0) === "?") { query = query.slice(1) } for (pairs = query.split("&"), i = 0, length = pairs.length; i < length; i++) { value = pairs[i]; index = value.indexOf("="); if (-1 < index) { appendTo(dict, decode(value.slice(0, index)), decode(value.slice(index + 1))) } else if (value.length) { appendTo(dict, decode(value), "") } } } else { if (isArray(query)) { for (i = 0, length = query.length; i < length; i++) { value = query[i]; appendTo(dict, value[0], value[1]) } } else { for (key in query) { appendTo(dict, key, query[key]) } } } } var isArray = Array.isArray, URLSearchParamsProto = URLSearchParams.prototype, find = /[!'\(\)~]|%20|%00/g, plus = /\+/g, replace = { "!": "%21", "'": "%27", "(": "%28", ")": "%29", "~": "%7E", "%20": "+", "%00": "\0" }, replacer = function (match) { return replace[match] }, secret = "__URLSearchParams__:" + Math.random(); function appendTo(dict, name, value) { if (name in dict) { dict[name].push("" + value) } else { dict[name] = isArray(value) ? value : ["" + value] } } function decode(str) { return decodeURIComponent(str.replace(plus, " ")) } function encode(str) { return encodeURIComponent(str).replace(find, replacer) } URLSearchParamsProto.append = function append(name, value) { appendTo(this[secret], name, value) }; URLSearchParamsProto["delete"] = function del(name) { delete this[secret][name] }; URLSearchParamsProto.get = function get(name) { var dict = this[secret]; return name in dict ? dict[name][0] : null }; URLSearchParamsProto.getAll = function getAll(name) { var dict = this[secret]; return name in dict ? dict[name].slice(0) : [] }; URLSearchParamsProto.has = function has(name) { return name in this[secret] }; URLSearchParamsProto.set = function set(name, value) { this[secret][name] = ["" + value] }; URLSearchParamsProto.forEach = function forEach(callback, thisArg) { var dict = this[secret]; Object.getOwnPropertyNames(dict).forEach(function (name) { dict[name].forEach(function (value) { callback.call(thisArg, value, name, this) }, this) }, this) }; URLSearchParamsProto.toJSON = function toJSON() { return {} }; URLSearchParamsProto.toString = function toString() { var dict = this[secret], query = [], i, key, name, value; for (key in dict) { name = encode(key); for (i = 0, value = dict[key]; i < value.length; i++) { query.push(name + "=" + encode(value[i])) } } return query.join("&") }; var dP = Object.defineProperty, gOPD = Object.getOwnPropertyDescriptor, createSearchParamsPollute = function (search) { function append(name, value) { URLSearchParamsProto.append.call(this, name, value); name = this.toString(); search.set.call(this._usp, name ? "?" + name : "") } function del(name) { URLSearchParamsProto["delete"].call(this, name); name = this.toString(); search.set.call(this._usp, name ? "?" + name : "") } function set(name, value) { URLSearchParamsProto.set.call(this, name, value); name = this.toString(); search.set.call(this._usp, name ? "?" + name : "") } return function (sp, value) { sp.append = append; sp["delete"] = del; sp.set = set; return dP(sp, "_usp", { configurable: true, writable: true, value: value }) } }, createSearchParamsCreate = function (polluteSearchParams) { return function (obj, sp) { dP(obj, "_searchParams", { configurable: true, writable: true, value: polluteSearchParams(sp, obj) }); return sp } }, updateSearchParams = function (sp) { var append = sp.append; sp.append = URLSearchParamsProto.append; URLSearchParams.call(sp, sp._usp.search.slice(1)); sp.append = append }, verifySearchParams = function (obj, Class) { if (!(obj instanceof Class)) throw new TypeError("'searchParams' accessed on an object that " + "does not implement interface " + Class.name) }, upgradeClass = function (Class) { var ClassProto = Class.prototype, searchParams = gOPD(ClassProto, "searchParams"), href = gOPD(ClassProto, "href"), search = gOPD(ClassProto, "search"), createSearchParams; if (!searchParams && search && search.set) { createSearchParams = createSearchParamsCreate(createSearchParamsPollute(search)); Object.defineProperties(ClassProto, { href: { get: function () { return href.get.call(this) }, set: function (value) { var sp = this._searchParams; href.set.call(this, value); if (sp) updateSearchParams(sp) } }, search: { get: function () { return search.get.call(this) }, set: function (value) { var sp = this._searchParams; search.set.call(this, value); if (sp) updateSearchParams(sp) } }, searchParams: { get: function () { verifySearchParams(this, Class); return this._searchParams || createSearchParams(this, new URLSearchParams(this.search.slice(1))) }, set: function (sp) { verifySearchParams(this, Class); createSearchParams(this, sp) } } }) } }; upgradeClass(HTMLAnchorElement); if (/^function|object$/.test(typeof URL) && URL.prototype) upgradeClass(URL); return URLSearchParams }(); (function (URLSearchParamsProto) { var iterable = function () { try { return !!Symbol.iterator } catch (error) { return false } }(); if (!("forEach" in URLSearchParamsProto)) { URLSearchParamsProto.forEach = function forEach(callback, thisArg) { var names = Object.create(null); this.toString().replace(/=[\s\S]*?(?:&|$)/g, "=").split("=").forEach(function (name) { if (!name.length || name in names) return; (names[name] = this.getAll(name)).forEach(function (value) { callback.call(thisArg, value, name, this) }, this) }, this) } } if (!("keys" in URLSearchParamsProto)) { URLSearchParamsProto.keys = function keys() { var items = []; this.forEach(function (value, name) { items.push(name) }); var iterator = { next: function () { var value = items.shift(); return { done: value === undefined, value: value } } }; if (iterable) { iterator[Symbol.iterator] = function () { return iterator } } return iterator } } if (!("values" in URLSearchParamsProto)) { URLSearchParamsProto.values = function values() { var items = []; this.forEach(function (value) { items.push(value) }); var iterator = { next: function () { var value = items.shift(); return { done: value === undefined, value: value } } }; if (iterable) { iterator[Symbol.iterator] = function () { return iterator } } return iterator } } if (!("entries" in URLSearchParamsProto)) { URLSearchParamsProto.entries = function entries() { var items = []; this.forEach(function (value, name) { items.push([name, value]) }); var iterator = { next: function () { var value = items.shift(); return { done: value === undefined, value: value } } }; if (iterable) { iterator[Symbol.iterator] = function () { return iterator } } return iterator } } if (iterable && !(Symbol.iterator in URLSearchParamsProto)) { URLSearchParamsProto[Symbol.iterator] = URLSearchParamsProto.entries } if (!("sort" in URLSearchParamsProto)) { URLSearchParamsProto.sort = function sort() { var entries = this.entries(), entry = entries.next(), done = entry.done, keys = [], values = Object.create(null), i, key, value; while (!done) { value = entry.value; key = value[0]; keys.push(key); if (!(key in values)) { values[key] = [] } values[key].push(value[1]); entry = entries.next(); done = entry.done } keys.sort(); for (i = 0; i < keys.length; i++) { this["delete"](keys[i]) } for (i = 0; i < keys.length; i++) { key = keys[i]; this.append(key, values[key].shift()) } } } })(URLSearchParams.prototype);
/*
 *  Copyright 2017-2020 Campaign Deputy LLC.
 * 
 * 
 */

$(function () { 
    $('[data-toggle="offcanvas"]').on("click", function () {
        $('.sidebar-offcanvas').toggleClass('active')
    });
    $('[data-toggle="minimize"]').on("click", function () {
        if (($('body').hasClass('sidebar-toggle-display')) || ($('body').hasClass('sidebar-absolute'))) {
            $('body').toggleClass('sidebar-hidden');
        } else {
            $('body').toggleClass('sidebar-icon-only');
        }
    });


    axios.defaults.headers.common['X-CSRF-TOKEN'] = $("body").data("forgery-token");

    if (!$.fn.serializeObject) {
        $.fn.serializeObject = function () {
            var o = {};
            var a = this.serializeArray();
            $.each(a, function () {
                if (o[this.name] !== undefined) {
                    console.log(this.name);
                    if (!o[this.name].push) {
                        o[this.name] = [o[this.name]];
                    }
                    o[this.name].push(this.value || '');

                } else {
                    o[this.name] = this.value || '';

                }

            });
            return o;
        };
    }
 
    Handlebars.registerHelper('fullName', function (data) {
        if (data.fullName) {
            return data.fullName;
        }
        return data.nameFirst + " " + data.nameLast;
    });
    Handlebars.registerHelper('formatCurrency', function (value) {
        if (value > 0) {
            return "$" + value.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
        } else {
            return "";
        }
    });
    Handlebars.registerHelper('formatDate', function (value) {
        if (moment(value).isValid()) {
            return moment(value).format("L") + " ago";
        }
        return '';
    });
    Handlebars.registerHelper('formatHumanReadableDate', function (value) {
        if (moment(value).isValid()) {
            return moment(value).fromNow(); //format("L").
        }
        return '';
    });

    Handlebars.registerHelper('formatNumericDate', function (value) {
        if (moment(value).isValid()) {
            return moment(value).format("L");
        }
        return '';
    });

    Handlebars.registerHelper('formatMaritalStatus', function (value) {
        if (!value) return "Unknown";
        switch (value) {
            case 0:
                return "Unknown";
            case 1:
                return "Single";
            case 2:
                return "Married";
            case 3:
                return "Widowed";
        }
    }); 
    Handlebars.registerHelper('formatPhoneType', function (value) {
        if (!value) return "Unknown";
        /*
         *  Home = 1,
        Work = 2,
        Cell = 3 */
        switch (value) {
            case 0:
                return "Unknown";
            case 1:
                return "Home";
            case 2:
                return "Work";
            case 3:
                return "Cell";
        }
    });
    Handlebars.registerHelper('formatPledgeType', function (value) {
        if (!value) return "Unknown";
        switch (value) {
            case 0:
                return "Unknown";
            case 1:
                return "To Give";
            case 2:
                return "To Raise";
        }
    });
    Handlebars.registerHelper('formatCallResult', function (value) {
        //if (!value) return "Unknown";
        switch (value) {
            
            case 1:
                return "No Answer";
            case 2:
                return "Call Back";
            case 3:
                return "Left Message";
            case 4:
                return "Wrong Number"; 
            case 500:
                return "Incoming Answered";
            case 0:
            default:
                return "Answered";
        }
    });
    Handlebars.registerHelper('formatTimeDuration', function (value) { 
        var hours = Math.floor(value / 3600);
        var minutes = Math.floor((value - (hours * 3600)) / 60);
        var seconds = value - (hours * 3600) - (minutes * 60);
        var time = "";

        if (!value)
            return "";
        /*jslint eqeq: true*/
        if (hours != 0) {
            time = hours + ":";
        }
        if (minutes != 0 || time !== "") {
            minutes = (minutes < 10 && time !== "") ? "0" + minutes : String(minutes);
            time += minutes + ":";
        }
        if (time === "") {
            time = seconds + "s";
        }
        else {
            time += (seconds < 10) ? "0" + seconds : String(seconds);
        }
        return time;
    });


    


    Handlebars.registerHelper("formatPhoneNumber", function (phoneNumber) {
        if (phoneNumber === null || typeof (phoneNumber) === "undefined") {
            return '';
        }
        phoneNumber = phoneNumber.toString();
        if (phoneNumber.length < 7) {
            return phoneNumber;
        }
        if (phoneNumber.length === 10) {
            return "(" + phoneNumber.substr(0, 3) + ") " + phoneNumber.substr(3, 3) + "-" + phoneNumber.substr(6, 4);
        }
        if (phoneNumber.length < 10) {
            return  phoneNumber.substr(0, 3) + "-" + phoneNumber.substr(4, 4) + ' ' + phoneNumber.substr(7, phoneNumber.length - 7);
        }
        if (phoneNumber.length > 10) {
            return "(" + phoneNumber.substr(0, 3) + ") " + phoneNumber.substr(3, 3) + "-" + phoneNumber.substr(6, 4) + ' ' + phoneNumber.substr(10, phoneNumber.length-10);
        }
    });
    Handlebars.registerHelper('ifCond', function (v1, operator, v2, options) {

        switch (operator) {
            case '==':
                return (v1 == v2) ? options.fn(this) : options.inverse(this);
            case '===':
                return (v1 === v2) ? options.fn(this) : options.inverse(this);
            case '!=':
                return (v1 != v2) ? options.fn(this) : options.inverse(this);
            case '!==':
                return (v1 !== v2) ? options.fn(this) : options.inverse(this);
            case '<':
                return (v1 < v2) ? options.fn(this) : options.inverse(this);
            case '<=':
                return (v1 <= v2) ? options.fn(this) : options.inverse(this);
            case '>':
                return (v1 > v2) ? options.fn(this) : options.inverse(this);
            case '>=':
                return (v1 >= v2) ? options.fn(this) : options.inverse(this);
            case '&&':
                return (v1 && v2) ? options.fn(this) : options.inverse(this);
            case '||':
                return (v1 || v2) ? options.fn(this) : options.inverse(this);
            default:
                return options.inverse(this);
        }
    });
    Handlebars.registerHelper('trimString', function (passedString, start, length) {
        var mlength = length, preS = '', tailS = '';
        if (start > 0 && passedString.length > 3) {
            preS = '...';
            mlength = length - 3;
        };
        if (passedString.length > (start + length)) {
            tailS = '...';
            mlength = mlength - 3;
        };
        var theString = preS + passedString.substr(start, mlength) + tailS;
        return new Handlebars.SafeString(theString);
    });


    Handlebars.registerHelper('bytesToHuman',function bytesToSize(bytes) {
        var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        if (bytes == 0) return '0 Byte';
        var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
        return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
    });

    Handlebars.registerHelper('select', function (value, options) {
        var $el = $('<select />').html(options.fn(this));
        $el.find('[value="' + value + '"]').attr({ 'selected': 'selected' });
        return $el.html();
    }); 
});


var cd_usStates = [
    { name: 'ALABAMA', abbreviation: 'AL' },
    { name: 'ALASKA', abbreviation: 'AK' },
    { name: 'AMERICAN SAMOA', abbreviation: 'AS' },
    { name: 'ARIZONA', abbreviation: 'AZ' },
    { name: 'ARKANSAS', abbreviation: 'AR' },
    { name: 'CALIFORNIA', abbreviation: 'CA' },
    { name: 'COLORADO', abbreviation: 'CO' },
    { name: 'CONNECTICUT', abbreviation: 'CT' },
    { name: 'DELAWARE', abbreviation: 'DE' },
    { name: 'DISTRICT OF COLUMBIA', abbreviation: 'DC' },
    { name: 'FEDERATED STATES OF MICRONESIA', abbreviation: 'FM' },
    { name: 'FLORIDA', abbreviation: 'FL' },
    { name: 'GEORGIA', abbreviation: 'GA' },
    { name: 'GUAM', abbreviation: 'GU' },
    { name: 'HAWAII', abbreviation: 'HI' },
    { name: 'IDAHO', abbreviation: 'ID' },
    { name: 'ILLINOIS', abbreviation: 'IL' },
    { name: 'INDIANA', abbreviation: 'IN' },
    { name: 'IOWA', abbreviation: 'IA' },
    { name: 'KANSAS', abbreviation: 'KS' },
    { name: 'KENTUCKY', abbreviation: 'KY' },
    { name: 'LOUISIANA', abbreviation: 'LA' },
    { name: 'MAINE', abbreviation: 'ME' },
    { name: 'MARSHALL ISLANDS', abbreviation: 'MH' },
    { name: 'MARYLAND', abbreviation: 'MD' },
    { name: 'MASSACHUSETTS', abbreviation: 'MA' },
    { name: 'MICHIGAN', abbreviation: 'MI' },
    { name: 'MINNESOTA', abbreviation: 'MN' },
    { name: 'MISSISSIPPI', abbreviation: 'MS' },
    { name: 'MISSOURI', abbreviation: 'MO' },
    { name: 'MONTANA', abbreviation: 'MT' },
    { name: 'NEBRASKA', abbreviation: 'NE' },
    { name: 'NEVADA', abbreviation: 'NV' },
    { name: 'NEW HAMPSHIRE', abbreviation: 'NH' },
    { name: 'NEW JERSEY', abbreviation: 'NJ' },
    { name: 'NEW MEXICO', abbreviation: 'NM' },
    { name: 'NEW YORK', abbreviation: 'NY' },
    { name: 'NORTH CAROLINA', abbreviation: 'NC' },
    { name: 'NORTH DAKOTA', abbreviation: 'ND' },
    { name: 'NORTHERN MARIANA ISLANDS', abbreviation: 'MP' },
    { name: 'OHIO', abbreviation: 'OH' },
    { name: 'OKLAHOMA', abbreviation: 'OK' },
    { name: 'OREGON', abbreviation: 'OR' },
    { name: 'PALAU', abbreviation: 'PW' },
    { name: 'PENNSYLVANIA', abbreviation: 'PA' },
    { name: 'PUERTO RICO', abbreviation: 'PR' },
    { name: 'RHODE ISLAND', abbreviation: 'RI' },
    { name: 'SOUTH CAROLINA', abbreviation: 'SC' },
    { name: 'SOUTH DAKOTA', abbreviation: 'SD' },
    { name: 'TENNESSEE', abbreviation: 'TN' },
    { name: 'TEXAS', abbreviation: 'TX' },
    { name: 'UTAH', abbreviation: 'UT' },
    { name: 'VERMONT', abbreviation: 'VT' },
    { name: 'VIRGIN ISLANDS', abbreviation: 'VI' },
    { name: 'VIRGINIA', abbreviation: 'VA' },
    { name: 'WASHINGTON', abbreviation: 'WA' },
    { name: 'WEST VIRGINIA', abbreviation: 'WV' },
    { name: 'WISCONSIN', abbreviation: 'WI' },
    { name: 'WYOMING', abbreviation: 'WY' }
];
//https://github.com/moment/moment-timezone/issues/281
var netToMomentJSMap = {
    "Dateline Standard Time": "Etc/GMT+12",
    "UTC-11": "Etc/GMT+11",
    "Aleutian Standard Time": "America/Adak",
    "Hawaiian Standard Time": "Pacific/Honolulu",
    "Marquesas Standard Time": "Pacific/Marquesas",
    "Alaskan Standard Time": "America/Anchorage",
    "UTC-09": "Etc/GMT+9",
    "Pacific Standard Time (Mexico)": "America/Tijuana",
    "UTC-08": "Etc/GMT+8",
    "Pacific Standard Time": "America/Los_Angeles",
    "US Mountain Standard Time": "America/Phoenix",
    "Mountain Standard Time (Mexico)": "America/Chihuahua",
    "Mountain Standard Time": "America/Denver",
    "Central America Standard Time": "America/Guatemala",
    "Central Standard Time": "America/Chicago",
    "Easter Island Standard Time": "Pacific/Easter",
    "Central Standard Time (Mexico)": "America/Mexico_City",
    "Canada Central Standard Time": "America/Regina",
    "SA Pacific Standard Time": "America/Bogota",
    "Eastern Standard Time (Mexico)": "America/Cancun",
    "Eastern Standard Time": "America/New_York",
    "Haiti Standard Time": "America/Port-au-Prince",
    "Cuba Standard Time": "America/Havana",
    "US Eastern Standard Time": "America/Indianapolis",
    "Paraguay Standard Time": "America/Asuncion",
    "Atlantic Standard Time": "America/Halifax",
    "Venezuela Standard Time": "America/Caracas",
    "Central Brazilian Standard Time": "America/Cuiaba",
    "SA Western Standard Time": "America/La_Paz",
    "Pacific SA Standard Time": "America/Santiago",
    "Turks And Caicos Standard Time": "America/Grand_Turk",
    "Newfoundland Standard Time": "America/St_Johns",
    "Tocantins Standard Time": "America/Araguaina",
    "E. South America Standard Time": "America/Sao_Paulo",
    "SA Eastern Standard Time": "America/Cayenne",
    "Argentina Standard Time": "America/Buenos_Aires",
    "Greenland Standard Time": "America/Godthab",
    "Montevideo Standard Time": "America/Montevideo",
    "Magallanes Standard Time": "America/Punta_Arenas",
    "Saint Pierre Standard Time": "America/Miquelon",
    "Bahia Standard Time": "America/Bahia",
    "UTC-02": "Etc/GMT+2",
    "Azores Standard Time": "Atlantic/Azores",
    "Cape Verde Standard Time": "Atlantic/Cape_Verde",
    "UTC": "Etc/GMT",
    "Morocco Standard Time": "Africa/Casablanca",
    "GMT Standard Time": "Europe/London",
    "Greenwich Standard Time": "Atlantic/Reykjavik",
    "W. Europe Standard Time": "Europe/Berlin",
    "Central Europe Standard Time": "Europe/Budapest",
    "Romance Standard Time": "Europe/Paris",
    "Central European Standard Time": "Europe/Warsaw",
    "W. Central Africa Standard Time": "Africa/Lagos",
    "Jordan Standard Time": "Asia/Amman",
    "GTB Standard Time": "Europe/Bucharest",
    "Middle East Standard Time": "Asia/Beirut",
    "Egypt Standard Time": "Africa/Cairo",
    "E. Europe Standard Time": "Europe/Chisinau",
    "Syria Standard Time": "Asia/Damascus",
    "West Bank Standard Time": "Asia/Hebron",
    "South Africa Standard Time": "Africa/Johannesburg",
    "FLE Standard Time": "Europe/Kiev",
    "Israel Standard Time": "Asia/Jerusalem",
    "Kaliningrad Standard Time": "Europe/Kaliningrad",
    "Sudan Standard Time": "Africa/Khartoum",
    "Libya Standard Time": "Africa/Tripoli",
    "Namibia Standard Time": "Africa/Windhoek",
    "Arabic Standard Time": "Asia/Baghdad",
    "Turkey Standard Time": "Europe/Istanbul",
    "Arab Standard Time": "Asia/Riyadh",
    "Belarus Standard Time": "Europe/Minsk",
    "Russian Standard Time": "Europe/Moscow",
    "E. Africa Standard Time": "Africa/Nairobi",
    "Iran Standard Time": "Asia/Tehran",
    "Arabian Standard Time": "Asia/Dubai",
    "Astrakhan Standard Time": "Europe/Astrakhan",
    "Azerbaijan Standard Time": "Asia/Baku",
    "Russia Time Zone 3": "Europe/Samara",
    "Mauritius Standard Time": "Indian/Mauritius",
    "Saratov Standard Time": "Europe/Saratov",
    "Georgian Standard Time": "Asia/Tbilisi",
    "Caucasus Standard Time": "Asia/Yerevan",
    "Afghanistan Standard Time": "Asia/Kabul",
    "West Asia Standard Time": "Asia/Tashkent",
    "Ekaterinburg Standard Time": "Asia/Yekaterinburg",
    "Pakistan Standard Time": "Asia/Karachi",
    "India Standard Time": "Asia/Calcutta",
    "Sri Lanka Standard Time": "Asia/Colombo",
    "Nepal Standard Time": "Asia/Katmandu",
    "Central Asia Standard Time": "Asia/Almaty",
    "Bangladesh Standard Time": "Asia/Dhaka",
    "Omsk Standard Time": "Asia/Omsk",
    "Myanmar Standard Time": "Asia/Rangoon",
    "SE Asia Standard Time": "Asia/Bangkok",
    "Altai Standard Time": "Asia/Barnaul",
    "W. Mongolia Standard Time": "Asia/Hovd",
    "North Asia Standard Time": "Asia/Krasnoyarsk",
    "N. Central Asia Standard Time": "Asia/Novosibirsk",
    "Tomsk Standard Time": "Asia/Tomsk",
    "China Standard Time": "Asia/Shanghai",
    "North Asia East Standard Time": "Asia/Irkutsk",
    "Singapore Standard Time": "Asia/Singapore",
    "W. Australia Standard Time": "Australia/Perth",
    "Taipei Standard Time": "Asia/Taipei",
    "Ulaanbaatar Standard Time": "Asia/Ulaanbaatar",
    "Aus Central W. Standard Time": "Australia/Eucla",
    "Transbaikal Standard Time": "Asia/Chita",
    "Tokyo Standard Time": "Asia/Tokyo",
    "North Korea Standard Time": "Asia/Pyongyang",
    "Korea Standard Time": "Asia/Seoul",
    "Yakutsk Standard Time": "Asia/Yakutsk",
    "Cen. Australia Standard Time": "Australia/Adelaide",
    "AUS Central Standard Time": "Australia/Darwin",
    "E. Australia Standard Time": "Australia/Brisbane",
    "AUS Eastern Standard Time": "Australia/Sydney",
    "West Pacific Standard Time": "Pacific/Port_Moresby",
    "Tasmania Standard Time": "Australia/Hobart",
    "Vladivostok Standard Time": "Asia/Vladivostok",
    "Lord Howe Standard Time": "Australia/Lord_Howe",
    "Bougainville Standard Time": "Pacific/Bougainville",
    "Russia Time Zone 10": "Asia/Srednekolymsk",
    "Magadan Standard Time": "Asia/Magadan",
    "Norfolk Standard Time": "Pacific/Norfolk",
    "Sakhalin Standard Time": "Asia/Sakhalin",
    "Central Pacific Standard Time": "Pacific/Guadalcanal",
    "Russia Time Zone 11": "Asia/Kamchatka",
    "New Zealand Standard Time": "Pacific/Auckland",
    "UTC+12": "Etc/GMT-12",
    "Fiji Standard Time": "Pacific/Fiji",
    "Chatham Islands Standard Time": "Pacific/Chatham",
    "UTC+13": "Etc/GMT-13",
    "Tonga Standard Time": "Pacific/Tongatapu",
    "Samoa Standard Time": "Pacific/Apia",
    "Line Islands Standard Time": "Pacific/Kiritimati"
}

// https://tc39.github.io/ecma262/#sec-array.prototype.includes
if (!Array.prototype.includes) {
    Object.defineProperty(Array.prototype, 'includes', {
        value: function (valueToFind, fromIndex) {

            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }

            // 1. Let O be ? ToObject(this value).
            var o = Object(this);

            // 2. Let len be ? ToLength(? Get(O, "length")).
            var len = o.length >>> 0;

            // 3. If len is 0, return false.
            if (len === 0) {
                return false;
            }

            // 4. Let n be ? ToInteger(fromIndex).
            //    (If fromIndex is undefined, this step produces the value 0.)
            var n = fromIndex | 0;

            // 5. If n ≥ 0, then
            //  a. Let k be n.
            // 6. Else n < 0,
            //  a. Let k be len + n.
            //  b. If k < 0, let k be 0.
            var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

            function sameValueZero(x, y) {
                return x === y || (typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y));
            }

            // 7. Repeat, while k < len
            while (k < len) {
                // a. Let elementK be the result of ? Get(O, ! ToString(k)).
                // b. If SameValueZero(valueToFind, elementK) is true, return true.
                if (sameValueZero(o[k], valueToFind)) {
                    return true;
                }
                // c. Increase k by 1. 
                k++;
            }

            // 8. Return false
            return false;
        }
    });
}
if (!Array.prototype.find) {
    Object.defineProperty(Array.prototype, 'find', {
        value: function (predicate) {
            // 1. Let O be ? ToObject(this value).
            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }

            var o = Object(this);

            // 2. Let len be ? ToLength(? Get(O, "length")).
            var len = o.length >>> 0;

            // 3. If IsCallable(predicate) is false, throw a TypeError exception.
            if (typeof predicate !== 'function') {
                throw new TypeError('predicate must be a function');
            }

            // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
            var thisArg = arguments[1];

            // 5. Let k be 0.
            var k = 0;

            // 6. Repeat, while k < len
            while (k < len) {
                // a. Let Pk be ! ToString(k).
                // b. Let kValue be ? Get(O, Pk).
                // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
                // d. If testResult is true, return kValue.
                var kValue = o[k];
                if (predicate.call(thisArg, kValue, k, o)) {
                    return kValue;
                }
                // e. Increase k by 1.
                k++;
            }

            // 7. Return undefined.
            return undefined;
        },
        configurable: true,
        writable: true
    });
}
if (!String.prototype.startsWith) {
    Object.defineProperty(String.prototype, 'startsWith', {
        value: function (search, pos) {
            pos = !pos || pos < 0 ? 0 : +pos;
            return this.substring(pos, pos + search.length) === search;
        }
    });
}

function CDPublicSettings() {
    this.SmartyStreetsKey = '778070471884572'; 
    this.SmartyStreetsSuggestURL = 'https://us-autocomplete.api.smartystreets.com/suggest?auth-id=778070471884572'; 
    this.SmartyStreetsAddressURL = 'https://us-street.api.smartystreets.com/street-address?auth-id=778070471884572'; 
    this.MapBoxToken = 'pk.eyJ1Ijoiam9zaHVhYmFydGxleSIsImEiOiJjanplaGF4MTEwMmc2M2hvM2JwNXkxOXd0In0.OOQAPOCnXqs9KnngN5pW3A';
    this.MapBoxPlacesUrl = 'https://api.mapbox.com/geocoding/v5/mapbox.places/';
}
CDSettings = new CDPublicSettings();


window.CDChartColors = {
    primary: "#96d63f",
    primary_button:"#337ab7",
    secondary_button: "#a0a0a0",
    danger_button: "#f25f5c",
    colors: [
        "#96d63f",
        "#337ab7",
        "#333333",
        "#333333",
        "#333333",
        "#333333",
        "#333333",
        "#333333",
        "#333333",
        "#333333",
        "#333333",
        "#333333",
        "#333333",
        "#333333"
    ]
};


var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
        console.log(mutation.type);
        const label = document.querySelector(`label[for="${mutation.target.name}"]`)
        if (mutation.target.disabled || mutation.target.readonly) {
            label.classList.add("control-label-disabled");
        } else {
            label.classList.remove("control-label-disabled");
        }
    });
});
 //get the subtree but only the disabled and readonly attributes
var observerConfig = {
    attributes: true,
    childList: false,
    characterData: false,
    subtree: true,
    attributeFilter: ['disabled', 'readonly']
};

// In this case we'll listen to all changes to body and child nodes
var targetNode = document.body;
observer.observe(targetNode, observerConfig); 

 


CDeputyLists = new function () {
    this.getPeople = function (listId, doneFunction, failFunction) {
        $.ajax("/api/List/Persons/" + listId)
            .done(function (data) {
                if (cdeputyIsFunction(doneFunction)) {
                    doneFunction(data);
                }
            })
            .fail(function () {
                CDLogger.error("Global:Failed to get People from List");
                toastr.error("Error retreiving People from List.", "Error");
                if (cdeputyIsFunction(failFunction)) {
                    doneFunction(data);
                }
            })
            .always(function () {
                Loader.Hide();
            });
    };

    this.removePerson = function (listId, personId, doneFunction, failFunction) {
        $.ajax("/api/List/Person/" + listId + "/" + personId + "/", { type: 'DELETE' })
            .done(function (data) {
                if (cdeputyIsFunction(doneFunction)) {
                    doneFunction(data);
                }
            })
            .fail(function () {
                CDLogger.error("Global:Failed to remove person from List");
                toastr.error("Error remove Person from List.", "Error");
                if (cdeputyIsFunction(failFunction)) {
                    doneFunction(data);
                }
            })
            .always(function () {
                Loader.Hide();
            });
    };
}

CDeputyPaging = new function () {
    this.calculatePages = function (length, pageSize) {
        if (length > 0) {
            return Math.ceil(length / pageSize);
        } else {
            return 1;
        }
    };
    this.getPageData = function (data, pageNumber, pageSize) {
        if (pageNumber === 1) {
            return data.slice(0, pageSize);
        } else {
            return data.slice((pageNumber - 1) * pageSize, (pageNumber * pageSize));
        }
    };
    this.showNextButton = function (data, pageNumber, pageSize) {
        //console.log((pageNumber * pageSize));
        //console.log(data.length);
        if ((pageNumber * pageSize) > data.length) {
            return false;
        } else {
            return true;
        }
    };
    this.showPreviousButton = function (data, pageNumber, pageSize) {
        if (pageNumber > 1) {
            return true;
        }
        return false;
    };
};

CDeputyPerson = new function () {
    this.getPhones = function (personId, doneFunction, failFunction) {
        $.ajax("/api/Persons/" + personId + "/Phones")
            .done(function (data) {
                if (cdeputyIsFunction(doneFunction)) {
                    doneFunction(data);
                }
            })
            .fail(function () {
                CDLogger.error("Global:Failed to get Phones from Person");
                toastr.error("Error retreiving Phone numbers.", "Error");
                if (cdeputyIsFunction(failFunction)) {
                    doneFunction(data);
                }
            })
            .always(function () {
                Loader.Hide();
            });
    };   
}

function cdeputyIsFunction(object) {
    return !!(object && object.constructor && object.call && object.apply);
}

function  cdeputyIsEmptyOrSpaces(str) {
    return str === null || str.match(/^ *$/) !== null;
}

function cd_form_type(electionType) {
    if (electionType == "1") {
        return "Embed";
    } else if (electionType == "2") {
        return "Gravity Forms";
    } else if (electionType == "3") {
        return "Hosted";
    } else if (electionType == "4") {
        return "Landing Page";
    } else if (electionType == "5") {
        return "Zapier";
    } 
    return "";
}

function cd_election_name(electionType) {
    if (electionType == "1") {
        return "Primary";
    } else if (electionType == "2") {
        return "General";
    } else if (electionType == "3") {
        return "Special";
    }
    return "";
}

function ApplyPhoneMask(selector) {
    var phoneMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    // Assuming you have an input element in your HTML with the class .myInput
    var myInput = document.querySelector(selector);
    if (myInput) { 
        var maskedInputController = vanillaTextMask.maskInput({
            inputElement: myInput,
            mask: phoneMask
        });
    }
}

function ApplyE164PhoneMask(selector) {
    var phoneMask = ['+', /\d/,' ','(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    // Assuming you have an input element in your HTML with the class .myInput
    var myInput = document.querySelector(selector);
    if (myInput) {
        var maskedInputController = vanillaTextMask.maskInput({
            inputElement: myInput,
            mask: phoneMask
        });
    }
}

function ApplyPhoneMaskv2(selector) {
    var phoneMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    // Assuming you have an input element in your HTML with the class .myInput
    var myInput = document.querySelector(selector);
    $(selector).each(function (index) {
        var maskedInputController = vanillaTextMask.maskInput({
            inputElement: myInput,
            mask: phoneMask
        });
    });
}
 

function ApplyZipMask(selector) {
    var phoneMask = [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    // Assuming you have an input element in your HTML with the class .myInput
    var myInput = document.querySelector(selector);
    if (myInput) {
        var maskedInputController = vanillaTextMask.maskInput({
            inputElement: myInput,
            mask: phoneMask,
            showMask: false,
            guide: false
        });
    }
}

function ApplyDatePicker(selector) {
    $(selector).datepicker({ format: "mm/dd/yy", autoclose: true, orientation: "bottom", assumeNearbyYear: true });
}


function ApplyMoneyMask(selector) {
    const numberMask = createNumberMask.default({
        prefix: '',
        suffix: '',
        decimalLimit: 2,
        allowDecimal: true,
        allowNegative : false
    }) 
    // Assuming you have an input element in your HTML with the class .myInput
    $(selector).each(function (index) {
        var maskedInputController = vanillaTextMask.maskInput({
            inputElement: this,
            mask: numberMask,
            showMask: false,
        });
    });
}

function ApplyMoneyMaskNegatives(selector) {
    const numberMask = createNumberMask.default({
        prefix: '',
        suffix: '',
        decimalLimit: 2,
        allowDecimal: true,
        allowNegative: true
    })
    // Assuming you have an input element in your HTML with the class .myInput
    $(selector).each(function (index) {
        var maskedInputController = vanillaTextMask.maskInput({
            inputElement: this,
            mask: numberMask,
            showMask: false,
        });
    });
}

function cd_format_phone_number(phoneNumber) {
    if (phoneNumber === null) {
        return '';
    }
    phoneNumber = phoneNumber.toString();
    if (phoneNumber.length < 7) {
        return phoneNumber;
    }
    if (phoneNumber.length === 10) {
        return "(" + phoneNumber.substr(0, 3) + ") " + phoneNumber.substr(3, 3) + "-" + phoneNumber.substr(6, 4);
    }
    if (phoneNumber.length < 10) {
        return phoneNumber.substr(0, 3) + "-" + phoneNumber.substr(4, 4) + ' ' + phoneNumber.substr(7, phoneNumber.length - 7);
    }
    if (phoneNumber.length > 10) {
        return "(" + phoneNumber.substr(0, 3) + ") " + phoneNumber.substr(3, 3) + "-" + phoneNumber.substr(6, 4) + ' ' + phoneNumber.substr(10, phoneNumber.length - 10);
    }    
}
function cd_format_currency(value) {    
    if (value > 0) {
        return "$" + value.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
    } else {
        return "";
    }
}

function cd_number_format(number, decimals, dec_point, thousands_sep) { 
    var n = !isFinite(+number) ? 0 : +number,
        prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
        dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
        toFixedFix = function (n, prec) {
            // Fix for IE parseFloat(0.55).toFixed(0) = 0;
            var k = Math.pow(10, prec);
            return Math.round(n * k) / k;
        },
        s = (prec ? toFixedFix(n, prec) : Math.round(n)).toString().split('.');
    if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);
}


function cd_format_shortDate(value) {
    if (moment(value).isValid()) {
        return moment(value).format("L");
    }
    return '';
}
function AddressAutoComplete(id,hiddenId) {
    this.id = id;
    this.hiddenId = hiddenId;
    var xhr;
    $(this.id).autoComplete({        
        minChars: 4,
        source: function (term, suggest) {
            try { xhr.abort(); } catch (e) {
                //aborting the xhr statement
            }
            xhr = $.getJSON('https://us-autocomplete.api.smartystreets.com/suggest?prefix=' + encodeURIComponent(term) + '&auth-id=778070471884572', { q: term },
                function (data) {
                    var suggestions = [];
                    if (data.suggestions) {
                        for (i = 0; i < data.suggestions.length; i++)
                            suggestions.push(data.suggestions[i]);
                    }
                    suggest(suggestions);
                });
        },
        renderItem: function (item, search) {
            search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
            var re = new RegExp("(" + search.split(' ').join('|') + ")", "gi");
            return '<div class="autocomplete-suggestion" data-city="' + item.city + '" data-state="' + item.state + '" data-street-line="' + item.street_line + '" data-val="' + item.text  + '">' + item.text.replace(re, "<b>$1</b>") + '</div>';
            //search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
            //var re = new RegExp("(" + search.split(' ').join('|') + ")", "gi");
            //return '<div class="autocomplete-suggestion" data-langname="' + item[0] + '" data-lang="' + item[1] + '" data-val="' + search + '"><img src="img/' + item[1] + '.png"> ' + item[0].replace(re, "<b>$1</b>") + '</div>';
        },
        onSelect: function (e, term, item) {
            try {
                //appInsights.trackEvent("AddressAutoComplete_onSelect");
                //appInsights.trackMetric("AddressAutoComplete", 1, { Game: "GameName", Difficulty: "Hard" });

            } catch (error) { CDLogger.error(error); }

            e.preventDefault();
            var input = $(id);
            var fullAddress = item.data('street-line') + ',' + item.data('city') + ' ' + item.data('state');
            input.val(fullAddress);
            $(hiddenId).val(fullAddress);
            input.data('data-street-line', item.data('street-line'));
            input.data('data-city', item.data('city'));
            input.data('data-state', item.data('state'));

            //onAddressSearch


            //alert('Item "' + item.getAttribute('data-langname') + ' (' + item.getAttribute('data-lang') + ')" selected by ' + (e.type == 'keydown' ? 'pressing enter' : 'mouse click') + '.');
        }
    });
} 

function AddressAutoCompletev2(id, hiddenId, onAddressSearchComplete) {
    this.id = id;
    this.hiddenId = hiddenId;
    var xhr;
    $(this.id).autoComplete({
        minChars: 4,
        delay : 300,
        source: function (term, suggest) {
            try { xhr.abort(); } catch (e) {
                //aborting the xhr statement
            }
            xhr = $.getJSON('https://api.mapbox.com/geocoding/v5/mapbox.places/' + encodeURIComponent(term) + '.json?access_token=pk.eyJ1Ijoiam9zaHVhYmFydGxleSIsImEiOiJjanplaGF4MTEwMmc2M2hvM2JwNXkxOXd0In0.OOQAPOCnXqs9KnngN5pW3A&types=address&autocomplete=true&country=US', { q: term },
                function (data) {
                    var suggestions = [];
                    if (data.features) {
                        for (i = 0; i < data.features.length; i++)
                            suggestions.push(data.features[i]);
                    }
                    suggest(suggestions);
                });
        },
        renderItem: function (item, search) {
            console.log(item);
            var city = item.context.find(function (str) {
                return str.id.startsWith('place.')
            });
            var state = item.context.find(function (str) {
                return str.id.startsWith('region.')
            });
            var zip = item.context.find(function (str) {
                return str.id.startsWith('postcode.')
            });
            
            search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
            var re = new RegExp("(" + search.split(' ').join('|') + ")", "gi");
            return '<div class="autocomplete-suggestion" data-city="' + CDXss.sanatizeInput(city.text) + '" data-state="' + CDXss.sanatizeInput(state.short_code.replace('US-', '')) + '" data-zip="' + CDXss.sanatizeInput(zip.text) + '" data-street-line="'
                + item.street_line + '" data-val="' + item.place_name + '">' + item.place_name.replace(re, "<b>$1</b>") + '</div>';
        },
        onSelect: function (e, term, item) {
            e.preventDefault();
            var input = $(id);
            //quick check
            try {
                //appInsights.trackEvent("AddressAutoComplete_onSelect"); 
            } catch (error) { CDLogger.error(error); }

            var street = item.data('val').substring(0,item.data('val').indexOf(',')); 
 
            if (cdeputyIsFunction(onAddressSearchComplete)) {
                //if (data[0].components) {
                onAddressSearchComplete(street, '', (item.data('city') + ', ' + item.data('state') + ' ' + item.data('zip')), item.data('city'), item.data('state'), item.data('zip'), '');
                //} else {
                //    onAddressSearchComplete(street, '', data[0].last_line);
                //}
            } else {
                toastr.error("Error getting address");
            }
 
        }
        }); 
} 

function AddressAutoCompletev3(element, onAddressSearchComplete, onAddressSearchFailure) { 
    var xhr;
    $(element).autoComplete({
        minChars: 4,
        source: function (term, suggest) {
            try { xhr.abort(); } catch (e) {
                //aborting the xhr statement
            }
            xhr = $.getJSON('https://us-autocomplete.api.smartystreets.com/suggest?prefix=' + encodeURIComponent(term) + '&auth-id=778070471884572', { q: term },
                function (data) {
                    var suggestions = [];
                    if (data.suggestions) {
                        for (i = 0; i < data.suggestions.length; i++)
                            suggestions.push(data.suggestions[i]);
                    }
                    suggest(suggestions);
                });
        },
        renderItem: function (item, search) {
            search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
            var re = new RegExp("(" + search.split(' ').join('|') + ")", "gi");
            return '<div class="autocomplete-suggestion" data-city="' + item.city + '" data-state="' + item.state + '" data-street-line="' + item.street_line + '" data-val="' + item.text + '">' + item.text.replace(re, "<b>$1</b>") + '</div>';
            //search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
            //var re = new RegExp("(" + search.split(' ').join('|') + ")", "gi");
            //return '<div class="autocomplete-suggestion" data-langname="' + item[0] + '" data-lang="' + item[1] + '" data-val="' + search + '"><img src="img/' + item[1] + '.png"> ' + item[0].replace(re, "<b>$1</b>") + '</div>';
        },
        onSelect: function (e, term, item) {
            e.preventDefault(); 
            $.getJSON('https://us-street.api.smartystreets.com/street-address?street='
                + encodeURIComponent(item.data('street-line'))
                + '&city=' + encodeURIComponent(item.data('city'))
                + '&state=' + encodeURIComponent(item.data('state'))
                + '&auth-id=778070471884572')
                .done(function (data) {
                    if (data && data.length > 0 && cdeputyIsFunction(onAddressSearchComplete)) {
                        if (data[0].components) {
                            onAddressSearchComplete(data[0].delivery_line_1, data[0].delivery_line_2, data[0].last_line, data[0].components.city_name, data[0].components.state_abbreviation, data[0].components.zipcode, data[0].components.plus4_code, data[0].metadata.latitude, data[0].metadata.longitude, data[0].metadata.precision);
                        } else {
                            onAddressSearchComplete(data[0].delivery_line_1, data[0].delivery_line_2, data[0].last_line);
                        }
                    } else {
                        if (cdeputyIsFunction(onAddressSearchFailure)) {
                            onAddressSearchFailure();
                        } else {
                            toastr.error("Error getting address");
                        }
                    }
                })
                .fail(function () {
                    if (cdeputyIsFunction(onAddressSearchFailure)) {
                        onAddressSearchFailure();
                    } else {
                        toastr.error("Error getting address");
                    }
                });
        }
    });
}

function LoaderHelper() {
    this.Show = function () {
        $('#CampaignDeputyLoader').show();
    };
    this.Hide = function () {
        $('#CampaignDeputyLoader').hide();
    };
}
Loader = new LoaderHelper(); 

function XSSHelper() {
    this.sanatizeInput = function (input) {
        return xssFilters.inHTMLData(input);
    }; 
}
CDXss = new XSSHelper(); 




//xssFilters.inHTMLData(


function RollBarLogger() {
    this.critical = function (message, extraData) {
        Rollbar.critical(message, extraData);
    };
    this.error = function (message, extraData) {
        Rollbar.error(message, extraData);
    };
    this.warning = function (message, extraData) {
        Rollbar.warning(message, extraData);
    };
    this.info = function (message, extraData) {
        Rollbar.info(message, extraData);
    };
    this.debug = function (message, extraData) {
        Rollbar.debug(message, extraData);
    }; 
}
 
CDLogger = new RollBarLogger(); 

function PersonAutoComplete(id, hiddenId, onSelectFunction, excludePersonId) {
    this.id = id;
    this.hiddenId = hiddenId;
    var xhr;
    $(this.id).autoComplete({
        minChars: 3,
        source: function (term, suggest) {
            try { xhr.abort(); } catch (e) {
                //aborting the xhr statement
            }
            xhr = $.getJSON('/api/Suggest/People?term=' + term , { q: term },
                function (data) {
                    var suggestions = [];
                    for (i = 0; i < data.length; i++) {
                        if (excludePersonId && data[i].personId === excludePersonId)
                            continue;

                        suggestions.push(data[i]);
                    }
                    suggest(suggestions);
                });
        },
        renderItem: function (item, search) {
            //search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
            //var re = new RegExp("(" + search.split(' ').join('|') + ")", "gi"); 
            var row = '<div class="autocomplete-suggestion suggest-search-row-striped" data-person-ref="' + item._ref + '" data-person-api-ref="' + item._apiref + '" data-person-id="' + item.personId + '" data-person="' + CDXss.sanatizeInput(item.displayValue) + '" data-person-full-name="' + CDXss.sanatizeInput(item.personName.fullName) + '" >';
            if (item.personName) {
                row += "<div ><i class=\"fa fa-user\" aria-hidden=\"true\"></i> " + CDXss.sanatizeInput(item.personName.fullName) + "</div>";
            }
            if (item.address) {
                if (item.address.deliveryLine1) {
                    row += "<div class=\"address\">" + CDXss.sanatizeInput(item.address.deliveryLine1) + "</div>";
                }
                if (item.address.city || item.address.state) {
                    row += "<div class=\"address\">" + CDXss.sanatizeInput(item.address.city) + ", " + CDXss.sanatizeInput(item.address.stateAbbreviation) + "</div>";
                }
            }
            row += "</div>";
            return row;



            //search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
            //var re = new RegExp("(" + search.split(' ').join('|') + ")", "gi");
            //return '<div class="autocomplete-suggestion" data-langname="' + item[0] + '" data-lang="' + item[1] + '" data-val="' + search + '"><img src="img/' + item[1] + '.png"> ' + item[0].replace(re, "<b>$1</b>") + '</div>';
        },
        onSelect: function (e, term, item) {
            e.preventDefault();
            onSelectFunction(item);
            //var input = $(id);
            //var fullAddress = item.data('street-line') + ',' + item.data('city') + ' ' + item.data('state');
            //input.val(fullAddress);
            //$(hiddenId).val(fullAddress);
            //input.data('data-street-line', item.data('street-line'));
            //input.data('data-city', item.data('city'));
            //input.data('data-state', item.data('state'));

            //alert('Item "' + item.getAttribute('data-langname') + ' (' + item.getAttribute('data-lang') + ')" selected by ' + (e.type == 'keydown' ? 'pressing enter' : 'mouse click') + '.');
        }
    });
} 

function GlobalAutoComplete(id, hiddenId, onSelectFunction, width, leftOffset) {
    this.id = id;
    this.hiddenId = hiddenId;
    var xhr;
    var _globalAutoCompleteIndex = 0;
    $(this.id).autoComplete({
        minChars: 3,
        width: width != null ? width : "auto",
        leftOffset: leftOffset != null ? leftOffset : "none", 
        source: function (term, suggest) {
            try { xhr.abort(); } catch (e) {
                //aborting the xhr statement
            }
            _cdEvents.logEvent("global_autocomplete", { searchCharacters: term.length });

            xhr = $.getJSON('/api/Suggest/All?term=' + term, { q: term },
                function (data) {
                    _globalAutoCompleteIndex = 0;
                    var suggestions = [];
                    for (i = 0; i < data.length; i++)
                        suggestions.push(data[i]);
                    suggest(suggestions);
                });
        },
        renderItem: function (item, search) {
            _globalAutoCompleteIndex++;
            var row = '<div class="autocomplete-suggestion suggest-search-row-striped\" data-ref="' + item._ref + '" data-display="' + CDXss.sanatizeInput(item.displayValue) + '" data-index="' + _globalAutoCompleteIndex + '" >';
            if (item.personName) {
                row += "<div class=\"suggest-row-heading\"><span class=\"search-entity-org-person\"></span> "
                + CDXss.sanatizeInput(item.personName.fullName) + "</div>";
            } else if (item.organizationName) {
                row += "<div><span class=\"search-entity-org-prefix\"></span> " + CDXss.sanatizeInput(item.organizationName) + "</div>";
            }
            if (item.address) {
                if (item.address.deliveryLine1) {
                    row += "<div class=\"suggest-row-details address\">" + CDXss.sanatizeInput(item.address.deliveryLine1) + "</div>";
                }
                if (item.address.city || item.address.state) {
                    row += "<div class=\"suggest-row-details address\">" + CDXss.sanatizeInput(item.address.city) + ", " + CDXss.sanatizeInput(item.address.stateAbbreviation) + "</div>";
                }
            }
            if (item.phoneNumber) {
                row += "<div class=\"suggest-row-details phone-number\">" + CDXss.sanatizeInput(cd_format_phone_number(item.phoneNumber)) + "</div>";
            }
            if (item.emailAddress) {
                row += "<div class=\"suggest-row-details email-address\">" + CDXss.sanatizeInput(item.emailAddress) + "</div>";
            }
            row += "</div>";
            return row;
        },
        onSelect: function (e, term, item) {

            try {
                //appInsights.trackEvent("GlobalAutoComplete_onSelect", { index: item.data('index') });

                _cdEvents.logEvent("global_autocomplete_select", { index: item.data('index') });

                //appInsights.trackMetric("AddressAutoComplete", 1, { Game: "GameName", Difficulty: "Hard" });
            } catch (error) { CDLogger.error(error); }


            e.preventDefault();
            onSelectFunction(item);
        }
    });
} 

function OrganizationAutoComplete(id, hiddenId, onSelectFunction) {
    this.id = id;
    this.hiddenId = hiddenId;
    var xhr;
    $(this.id).autoComplete({
        minChars: 3,
        source: function (term, suggest) {
            try { xhr.abort(); } catch (e) {
                //aborting the xhr statement
            }
            xhr = $.getJSON('/api/Suggest/Organizations?term=' + term, { q: term },
                function (data) {
                    var suggestions = [];
                    for (i = 0; i < data.length; i++)
                        suggestions.push(data[i]);
                    suggest(suggestions);
                });
        },
        renderItem: function (item, search) {
            //search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
            //var re = new RegExp("(" + search.split(' ').join('|') + ")", "gi");
            return '<div class="autocomplete-suggestion" data-ref="' + item._ref + '" data-api-ref="' + item._apiref + '" data-organization="' + item.displayValue + '" >' + item.displayValue + '</div>';
            //search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
            //var re = new RegExp("(" + search.split(' ').join('|') + ")", "gi");
            //return '<div class="autocomplete-suggestion" data-langname="' + item[0] + '" data-lang="' + item[1] + '" data-val="' + search + '"><img src="img/' + item[1] + '.png"> ' + item[0].replace(re, "<b>$1</b>") + '</div>';
        },
        onSelect: function (e, term, item) {
            e.preventDefault();
            onSelectFunction(item);
            //var input = $(id);
            //var fullAddress = item.data('street-line') + ',' + item.data('city') + ' ' + item.data('state');
            //input.val(fullAddress);
            //$(hiddenId).val(fullAddress);
            //input.data('data-street-line', item.data('street-line'));
            //input.data('data-city', item.data('city'));
            //input.data('data-state', item.data('state'));

            //alert('Item "' + item.getAttribute('data-langname') + ' (' + item.getAttribute('data-lang') + ')" selected by ' + (e.type == 'keydown' ? 'pressing enter' : 'mouse click') + '.');
        }
    });
}


function ExcelExport(event, url, httpAction, data) {

        event.preventDefault();
        Loader.Show();
        var xhr = new XMLHttpRequest();
        xhr.open(httpAction, url, true);
        xhr.responseType = 'arraybuffer';
        xhr.onload = function () {
            if (this.status === 200) {
                var filename = ""; var disposition = xhr.getResponseHeader('Content-Disposition');
                if (disposition && disposition.indexOf('attachment') !== -1) {
                    var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    var matches = filenameRegex.exec(disposition);
                    if (matches != null && matches[1]) filename = matches[1].replace(/['"]/g, '');
                }
                var type = xhr.getResponseHeader('Content-Type');

                var blob = new Blob([this.response], { type: type });
                if (typeof window.navigator.msSaveBlob !== 'undefined') {
                    // IE workaround for "HTML7007: One or more blob URLs were revoked by closing the blob for which they were created. These URLs will no longer resolve as the data backing the URL has been freed."
                    window.navigator.msSaveBlob(blob, filename);
                } else {
                    var URL = window.URL || window.webkitURL;
                    var downloadUrl = URL.createObjectURL(blob);

                    if (filename) {
                        // use HTML5 a[download] attribute to specify filename
                        var a = document.createElement("a");
                        // safari doesn't support this yet
                        if (typeof a.download === 'undefined') {
                            window.location = downloadUrl;
                        } else {
                            a.href = downloadUrl;
                            a.download = filename;
                            document.body.appendChild(a);
                            a.click();
                        }
                    } else {
                        window.location = downloadUrl;
                    }
                    setTimeout(function () { URL.revokeObjectURL(downloadUrl); }, 100); // cleanup
                }
            }/* else {

            }*/
            Loader.Hide();
        };
        xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
        xhr.send(data);
} 


function cd_formatPhoneNumber(phoneNumber) {
    if (phoneNumber === null) {
        return '';
    }
    phoneNumber = phoneNumber.toString();
    if (phoneNumber.length < 7) {
        return phoneNumber;
    }
    if (phoneNumber.length >= 12 && phoneNumber.substr(0, 1)==="+") { 
        return "(" + phoneNumber.substr(2, 3) + ") " + phoneNumber.substr(5, 3) + "-" + phoneNumber.substr(8, 4);
    }

    if (phoneNumber.length === 10) {
        return "(" + phoneNumber.substr(0, 3) + ") " + phoneNumber.substr(3, 3) + "-" + phoneNumber.substr(6, 4);
    }
    if (phoneNumber.length < 10) {
        return phoneNumber.substr(0, 3) + "-" + phoneNumber.substr(4, 4) + ' ' + phoneNumber.substr(7, phoneNumber.length - 7);
    }
    if (phoneNumber.length > 10) {
        return "(" + phoneNumber.substr(0, 3) + ") " + phoneNumber.substr(3, 3) + "-" + phoneNumber.substr(6, 4) + ' ' + phoneNumber.substr(10, phoneNumber.length - 10);
    }
}

var LoginCheckClass = function LoginCheckClass(isloggedIn) {
    // Initialization
    this._LOGGED_IN = isloggedIn;
    if (this._LOGGED_IN) {
        var loginClass = this;
        store.set('idleTimerLastActivity', $.now());
        store.set('idleTimerLoggedOut', false);
        loginClass.Check();
    }
};
LoginCheckClass.prototype = {
    _LOG_IN_LIMIT: 1000 * 60 * 55,
    _LOG_IN_WARNING_TIME: 90,
    _LOG_IN_TIME: new Date(),
    _LOG_IN_INTERVAL: null,
    _LOG_OFF_POPUP_VISIBLE: false,
    Check: function () {
        //_instance because the window object becomes this when calling this method
        //console.log("Time Remaining:" + this.LogOnTimeRemaining());
        //var timeIdleTimeout = (store.get('idleTimerLastActivity') + (this._LOG_IN_LIMIT * 1000));

        if (this.LogOnTimeRemaining() <= this._LOG_IN_WARNING_TIME) {
            this.LogOffImpending();
            clearInterval(this._LOG_IN_INTERVAL);
            this._LOG_IN_INTERVAL = null;
        } else {
            var loginClass = this;
            if (this._LOG_IN_INTERVAL === null) {
                this._LOG_IN_INTERVAL = setInterval(function () { loginClass.Check(); }, 5000);
            }
        }
    },
    Reset: function () {
        var loginClass = this;
        $.get('/Settings/KeepAlive')
            .done(function () {
                loginClass._LOG_OFF_POPUP_VISIBLE = false;
                loginClass._LOG_IN_TIME = new Date();
                store.set('idleTimerLastActivity', $.now());
                loginClass.Check();
            })
            .fail(function () {
                toastr.error('Please check to make sure you are still logged in.', 'Login Check Error');
            });
        //
    },
    LogOff: function () {
        store.set('idleTimerLoggedOut', true);
        window.location = "/Account/PageExpired?ReturnUrl=" + window.location.href;
    },
    LogOnTimeRemaining: function LogOnTimeRemaining() {
        var lastPageLoadTime = store.get('idleTimerLastActivity');
        var timeLeft = new Date(lastPageLoadTime + this._LOG_IN_LIMIT);
        var dif = timeLeft.getTime() - new Date().getTime();
        var Seconds_from_T1_to_T2 = dif / 1000;
        var Seconds_Between_Dates = Math.ceil(Seconds_from_T1_to_T2);
        return Seconds_Between_Dates;
    },
    LogOffImpending: function () {
        this._LOG_OFF_POPUP_VISIBLE = true;
        var loginClass = this;
        this._LOG_OFF_DIALOG = $.confirm({
            icon: 'fa fa-warning',
            title: "Inactivity Warning",
            content: 'You will be logged out of the system in <span id=\"log-off-seconds\"></span> seconds.',
            type: 'red',
            typeAnimated: true,
            buttons: {
                Continue: function () {
                    loginClass.Reset();
                },
                LogOut: {
                    text: 'Log off!', // With spaces and symbols
                    action: function () {
                        loginClass.LogOff();
                    }
                }
            },
            onContentReady: function () {
                var self = this;
                console.log("OnContentReady");
                var scoping = function () {
                    loginClass._LogOffPopUpTimer(self);
                };
                scoping();
            },
        });
    },
    _LogOffPopUpTimer: function (self) {
        if (this._LOG_OFF_POPUP_VISIBLE === false) {
            return;
        }
        var loginClass = this;
        var Seconds_Between_Dates = this.LogOnTimeRemaining();
        //console.log(Seconds_Between_Dates);
        self.$content.find("#log-off-seconds").text(Seconds_Between_Dates);
        if (Seconds_Between_Dates > this._LOG_IN_WARNING_TIME) {
            this._LOG_OFF_DIALOG.close();
            this.Check();
            return; //clicked yes on another page or loaded another page.
        }

        if (store.get('idleTimerLoggedOut') === true) {
            window.location = "/Account/SessionExpired?ReturnUrl=" + window.location.href;
        }
        if (Seconds_Between_Dates >= 0) {
            setTimeout(function () {
                loginClass._LogOffPopUpTimer(self);
            }, 1000);
        } else {
            this.LogOff();
        }
    },
};
!function (a) {
    'use strict';

    // TOGGLE PUBLIC CLASS DEFINITION
    // ==============================

    var Toggle = function (element, options) {
        this.$element = $(element)
        this.options = $.extend({}, this.defaults(), options)
        this.render()
    }

    Toggle.VERSION = '3.7.0-beta'

    Toggle.DEFAULTS = {
        on: 'On',
        off: 'Off',
        onstyle: 'primary',
        offstyle: 'light',
        size: 'normal',
        style: '',
        width: null,
        height: null
    }

    Toggle.prototype.defaults = function () {
        return {
            on: this.$element.attr('data-on') || Toggle.DEFAULTS.on,
            off: this.$element.attr('data-off') || Toggle.DEFAULTS.off,
            onstyle: this.$element.attr('data-onstyle') || Toggle.DEFAULTS.onstyle,
            offstyle: this.$element.attr('data-offstyle') || Toggle.DEFAULTS.offstyle,
            size: this.$element.attr('data-size') || Toggle.DEFAULTS.size,
            style: this.$element.attr('data-style') || Toggle.DEFAULTS.style,
            width: this.$element.attr('data-width') || Toggle.DEFAULTS.width,
            height: this.$element.attr('data-height') || Toggle.DEFAULTS.height
        }
    }

    Toggle.prototype.render = function () {
        this._onstyle = 'btn-' + this.options.onstyle
        this._offstyle = 'btn-' + this.options.offstyle
        var size
            = this.options.size === 'large' || this.options.size === 'lg' ? 'btn-lg'
                : this.options.size === 'small' || this.options.size === 'sm' ? 'btn-sm'
                    : this.options.size === 'mini' || this.options.size === 'xs' ? 'btn-xs'
                        : ''
        var $toggleOn = $('<label for="' + this.$element.prop('id') + '" class="btn">').html(this.options.on)
            .addClass(this._onstyle + ' ' + size)
        var $toggleOff = $('<label for="' + this.$element.prop('id') + '" class="btn">').html(this.options.off)
            .addClass(this._offstyle + ' ' + size)
        var $toggleHandle = $('<span class="toggle-handle btn btn-light">')
            .addClass(size)
        var $toggleGroup = $('<div class="toggle-group">')
            .append($toggleOn, $toggleOff, $toggleHandle)
        var $toggle = $('<div class="toggle btn" data-toggle="toggle" role="button">')
            .addClass(this.$element.prop('checked') ? this._onstyle : this._offstyle + ' off')
            .addClass(size).addClass(this.options.style)

        this.$element.wrap($toggle)
        $.extend(this, {
            $toggle: this.$element.parent(),
            $toggleOn: $toggleOn,
            $toggleOff: $toggleOff,
            $toggleGroup: $toggleGroup
        })
        this.$toggle.append($toggleGroup)

        var width = this.options.width || Math.max($toggleOn.outerWidth(), $toggleOff.outerWidth()) + ($toggleHandle.outerWidth() / 2)
        var height = this.options.height || Math.max($toggleOn.outerHeight(), $toggleOff.outerHeight())
        $toggleOn.addClass('toggle-on')
        $toggleOff.addClass('toggle-off')
        this.$toggle.css({ width: width, height: height })
        if (this.options.height) {
            $toggleOn.css('line-height', $toggleOn.height() + 'px')
            $toggleOff.css('line-height', $toggleOff.height() + 'px')
        }
        this.update(true)
        this.trigger(true)
    }

    Toggle.prototype.toggle = function () {
        if (this.$element.prop('checked')) this.off()
        else this.on()
    }

    Toggle.prototype.on = function (silent) {
        if (this.$element.prop('disabled')) return false
        this.$toggle.removeClass(this._offstyle + ' off').addClass(this._onstyle)
        this.$element.prop('checked', true)
        if (!silent) this.trigger()
    }

    Toggle.prototype.off = function (silent) {
        if (this.$element.prop('disabled')) return false
        this.$toggle.removeClass(this._onstyle).addClass(this._offstyle + ' off')
        this.$element.prop('checked', false)
        if (!silent) this.trigger()
    }

    Toggle.prototype.enable = function () {
        this.$toggle.removeClass('disabled')
        this.$toggle.removeAttr('disabled')
        this.$element.prop('disabled', false)
    }

    Toggle.prototype.disable = function () {
        this.$toggle.addClass('disabled')
        this.$toggle.attr('disabled', 'disabled')
        this.$element.prop('disabled', true)
    }

    Toggle.prototype.update = function (silent) {
        if (this.$element.prop('disabled')) this.disable()
        else this.enable()
        if (this.$element.prop('checked')) this.on(silent)
        else this.off(silent)
    }

    Toggle.prototype.trigger = function (silent) {
        this.$element.off('change.bs.toggle')
        if (!silent) this.$element.change()
        this.$element.on('change.bs.toggle', $.proxy(function () {
            this.update()
        }, this))
    }

    Toggle.prototype.destroy = function () {
        this.$element.off('change.bs.toggle')
        this.$toggleGroup.remove()
        this.$element.removeData('bs.toggle')
        this.$element.unwrap()
    }

    // TOGGLE PLUGIN DEFINITION
    // ========================

    function Plugin(option) {
        var optArg = Array.prototype.slice.call(arguments, 1)[0]

        return this.each(function () {
            var $this = $(this)
            var data = $this.data('bs.toggle')
            var options = typeof option == 'object' && option

            if (!data) $this.data('bs.toggle', (data = new Toggle(this, options)))
            if (typeof option === 'string' && data[option] && typeof optArg === 'boolean') data[option](optArg)
            else if (typeof option === 'string' && data[option]) data[option]()
            //else if (option && !data[option]) console.log('bootstrap-toggle: error: method `'+ option +'` does not exist!');
        })
    }

    var old = $.fn.bootstrapToggle

    $.fn.bootstrapToggle = Plugin
    $.fn.bootstrapToggle.Constructor = Toggle

    // TOGGLE NO CONFLICT
    // ==================

    $.fn.toggle.noConflict = function () {
        $.fn.bootstrapToggle = old
        return this
    }

    // TOGGLE DATA-API
    // ===============

    $(function () {
        $('input[type=checkbox][data-toggle^=toggle]').bootstrapToggle()
    })

    $(document).on('click.bs.toggle', 'div[data-toggle^=toggle]', function (e) {
        var $checkbox = $(this).find('input[type=checkbox]')
        $checkbox.bootstrapToggle('toggle')
        e.preventDefault()
    })
}(jQuery);
